import { useParams } from 'react-router';
type ProposalUrlParameters = {
  id?: string;
};

/**
 * @deprecated This hook has been deprecated in favour of `useProposalIdFromParams`.
 *
 * This hook attempts to read the URL param proposalId from the URL, and cast the result to a Number.
 * If the proposal ID is not found, the return value will be NaN.
 *
 * @returns The proposalId from the URL param, cast to a Number using Number()
 */
export const useGetProposalIdFromURL = () => {
  const { id } = useParams<ProposalUrlParameters>();
  return Number(id);
};
